document.addEventListener("DOMContentLoaded", () => {
  var reviewlist_box = new Swiper(".review-list_box", {
    slidesPerGroup: 1,
    navigation: {
      nextEl: ".swiper-button-next-r",
      prevEl: ".swiper-button-prev-l",
    },
    pagination: ".swiper-pagination",
    observer: true,
    observeParents: true,
    breakpoints: {
      1000: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
      500: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });
});
